import script from "./AuditDetailsNotices.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuditDetailsNotices.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__